import { classifierColumns, classifierSchema } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
import { z } from 'zod';
export const missionLocationEntityName = 'missionLocation';
export const missionLocationDataSchema = classifierSchema.extend({
    type: z.string().trim().min(1),
    address: z.string().trim().min(1),
    address2: z.string().optional(),
    city: z.string().trim().min(1),
    state: z.string().trim().min(1),
    county: z.string().trim().min(1),
    zip: z.string().trim().min(1),
});
export const missionLocationColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { fullAddress: {
        type: 'string-required',
        index: true,
    }, search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
